// Generated by Melange

import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Stdlib__List from "melange/list.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function LibraryArticle(Props) {
  let page = Props.page;
  const intl = ReactIntl.useIntl();
  let tag;
  try {
    tag = Stdlib__List.hd(Stdlib__List.filter((function (t) {
      return t !== "Избранное";
    }), page.tags));
  }
  catch (exn){
    tag = "";
  }
  const readingTime = page.readingTime;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("p", {
        children: [
          JsxRuntime.jsx("span", {
            children: tag,
            className: "underline"
          }),
          " ･ ",
          page.title
        ],
        className: "paragraph-small text-gray-landing"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h2", {
            children: page.title,
            className: "h4 lg:h2 text-black-landing mt-4"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("p", {
                children: [
                  page.createdAtLongStr,
                  " · ",
                  String(readingTime),
                  Buhta_landing__I18n.trans(intl, "blog_min_read")
                ],
                className: "paragraph-small text-gray-landing"
              }),
              className: "flex mt-1 lg:mt-0"
            }),
            className: "lg:flex mt-4 justify-between flex-wrap"
          }),
          JsxRuntime.jsx("div", {
            className: "mt-6 lg:mt-10 content-container",
            dangerouslySetInnerHTML: {
              __html: page.render
            }
          })
        ]
      })
    ],
    className: "lg:w-200 px-6 sm:px-48 lg:px-0"
  });
}

const make = LibraryArticle;

export {
  make,
}
/* react-intl Not a pure module */
